import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	showMoreTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	showMoreTooltip: {
		id: 'issue-field-multi-group-picker-readview-full.multi-group-picker.compact.show-more-tooltip',
		defaultMessage: 'See more selected options',
		description: 'Label for trigger button to open a dialog with a list of selected options',
	},
});
export default messages;
